import { render, staticRenderFns } from "./secondAgent.vue?vue&type=template&id=5470fe40&scoped=true&"
import script from "./secondAgent.vue?vue&type=script&lang=js&"
export * from "./secondAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5470fe40",
  null
  
)

export default component.exports